import axios from "axios";

export const fetchTimeOutData = (token) => {
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  return axios.get(
    `${process.env.REACT_APP_API_URL}/v1/settings/global/mobile_app__inactivity_timeout`,
    {
      headers,
    }
  );
};
